export const PROVIDER_COLORS: Record<string, string> = {
  baidu: '#2932e1',
  quark: '#00bcd4',
  aliyun: '#ff6a00',
  '123pan': '#2f54eb',
  lanzou: '#1890ff',
  mega: '#d9272e',
  google_drive: '#4285f4',
  onedrive: '#0364b8',
  dropbox: '#0061ff',
  github: '#24292f',
  gitlab: '#fc6d26',
  bilibili: '#00a1d6',
  youtube: '#ff0000',
  official_site: '#52c41a',
  direct: '#faad14',
  magnet: '#722ed1',
  other: '#8c8c8c',
};

export function providerColor(key: string): string {
  return PROVIDER_COLORS[key] || '#8c8c8c';
}
